import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function saveCurrency(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  let currencyData = {
    doc_type: DocType.CURRENCY,
    name: util.toStringText(data.name),
    symbol: util.toStringText(data.symbol),
    code: util.toStringText(data.code),
    active: util.toBoolean(data.active),
    denominations: util.toObjectArray(data.denominations)
  };
  return common.saveDoc(app, {
    source: data,
    doc: currencyData,
    user,
  });
}

export function fetchCurrencyDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'currency/dropdown';

  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function deleteCurrency(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.CURRENCY
  });
}

export function fetchCurrencyById(app, params) {
  const { id } = params;
  const docType = DocType.CURRENCY;
  return common.getDoc(app, { id, docType });
}
